export default __webpack_public_path__ + "static/media/pictogramInvestments64.865e88be.svg";